import type { SelectOption } from '@presentation/components';
import type { Dayjs } from 'dayjs';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';
import type { MtBreederOnboardingFormValues } from '../MtBreederOnboarding';

export interface MtProfileBreederValues extends MtBreederOnboardingFormValues {
  language?: string;
  translations: string[];
  firstName?: string;
  lastName?: string;
  email?: string;
  phonePrefixCountry?: string;
  phone?: string;
  birthday?: Dayjs;
  gender?: string;
  displayName?: string;
}
export interface MtProfileBreederOptions {
  breeds: SelectOption<number>[];
}

export interface MtProfileBreederPageProps {
  options: MtProfileBreederOptions;
  mode: 'view' | 'edit';
  onSubmitForm: () => void;
  onCancelClick?: MouseEventHandler;
  onEditClick?: MouseEventHandler;
  onTranslationAddClick?: MouseEventHandler;
  onTranslationDeleteClick?: (event: MouseEvent, translation: string) => void;
  loading?: boolean;
  link?: LocationDescriptor;
  showCertificationFileField?: boolean;
}
